import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ClientAppResource from "./ClientAppResource";

class PersonalAccessClientAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'oauthPersonalAccessClient';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'oauth/personal-access-clients';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'clientUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            client: ClientAppResource
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            client: 'client_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            clientUuid: {
                type: 'string',
                presence: true,
            },
            createdAt: {
                datetime: true,
            },
            updatedAt: {
                datetime: true,
            },
        };
    }

}

export default PersonalAccessClientAppResource;
